import moment from 'moment';
import { useMemo } from 'react';
import { useFormatter } from 'shared/formatters';
import { SUBSCRIPTION_TYPE, Subscription } from 'types/IEquipmentEntry';

export interface SubscriptionInfo {
  hasPremium: boolean;
  isInitial: boolean;
  endsWithinDays: boolean;
  shouldShowExpiration: boolean;
  endsOn?: string;
  rawEndsOn?: string;
  nextPaymentDate?: string;
  rawNextPaymentDate?: string;
}

export default function useSubscriptionInfo(
  subscriptions: Subscription[] = [],
) {
  const { formatDate } = useFormatter();

  const subscriptionInfo = useMemo<SubscriptionInfo>(() => {
    const subscription =
      subscriptions.find(
        sub => sub.type === SUBSCRIPTION_TYPE.PREMIUM_TELEMATICS,
      ) ||
      subscriptions.find(
        sub => sub.type === SUBSCRIPTION_TYPE.INITIAL_TELEMATICS,
      );

    const endsOnMoment = subscription?.endDate
      ? moment(subscription.endDate)
      : undefined;

    const endsWithinDays = endsOnMoment
      ? endsOnMoment.isSameOrAfter(moment(), 'day') &&
        endsOnMoment.isSameOrBefore(moment().add(90, 'days'), 'day')
      : false;

    const hasNextPayment = !!subscription?.nextPaymentDate;

    const shouldShowExpiration = endsWithinDays || !hasNextPayment;

    return {
      hasPremium: !!subscription,
      isInitial: subscription?.type === SUBSCRIPTION_TYPE.INITIAL_TELEMATICS,
      endsWithinDays,
      shouldShowExpiration,
      endsOn: subscription?.endDate
        ? formatDate(subscription.endDate)
        : undefined,
      rawEndsOn: subscription?.endDate,
      nextPaymentDate: subscription?.nextPaymentDate
        ? formatDate(subscription.nextPaymentDate)
        : undefined,
      rawNextPaymentDate: subscription?.nextPaymentDate,
    };
  }, [subscriptions]);

  return subscriptionInfo;
}
